import { useQuery } from '@tanstack/react-query';
import type { Pricing } from '@masha/shared';
import { pluralCredits } from '@masha/shared';
import { api } from './api';

// Mirrors DEFAULT_SETTINGS in packages/db/src/settings.ts (the TMA cannot
// import @masha/db) — used only until GET /packages loads.
const FALLBACK: Pricing = { reels: 10, carousel: 10, rewrite: 10, uniq: 1 };

/** Prices in credits from GET /packages (settings table); DEFAULT_SETTINGS values until loaded. */
export function usePricing(): Pricing {
  const { data } = useQuery({
    queryKey: ['packages'],
    queryFn: () => api.listPackages(),
    staleTime: 5 * 60_000,
  });
  return data?.pricing ?? FALLBACK;
}

/** Button text for a paid rewrite: turbo makes it free, otherwise show the price. */
export function paidRewriteLabel(cost: number, turboUntil: string | null): string {
  if (turboUntil && new Date(turboUntil).getTime() > Date.now()) return 'Переписать (турбо)';
  return `Переписать (-${cost} ${pluralCredits(cost)})`;
}
